import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles, useTheme} from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { isNotEmpty, isDate } from '../../utils/Validator';
import { parseDate } from '../../utils/Utils';
import { formatDate } from '../../utils/Format';

import Paper from '@material-ui/core/Paper';

//import Grid from "@material-ui/core/Grid";


function desc(a, b, orderBy) {
    let c = a[orderBy];
    let d = b[orderBy];

    console.log(`typeof a[${orderBy}]: " ${typeof a[orderBy]}`);
    console.log(c);
    console.log(`typeof b[${orderBy}]: " ${typeof b[orderBy]}`);
    console.log(d);

    console.log("instanceof date == " + (c instanceof Date));

    // !!! will have to try date first because a date comes back as a string
    if (isNotEmpty(c)) {
        if (typeof c === "string") {
            c = c.toUpperCase();
        } else if (isDate(c)) {
            c = parseDate(c);
        }
    }

    if (isNotEmpty(d)) {
        if (typeof d === "string") {
            d = d.toUpperCase();
        } else if (isDate(d)) {
            d = parseDate(d);
        }
    }

    if (d < c) {
        return -1;
    }

    if (d > c) {
        return 1;
    }

    return 0;
}

function
stableSort(array, cmp) {

    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headCells = [
    
    {id: 'claimNumber', fid: 'claimNumber', numeric: false, disablePadding: true, label: 'Claim Number', filterLable:'Claim Number', width:'15rem'},
    {id: 'claimantName', fid: 'claimantName', numeric: false, disablePadding: true, label: 'Claimant  Name', filterLable:'Claimant  Name',width:'20rem'},
    {id: 'dob', fid: 'dob', numeric: false, disablePadding: true, label: 'Date Of Birth',filterLable:'DOB',width:'9rem'},
    {id: 'doi', fid: 'doi', numeric: false, disablePadding: true, label: 'Date of Injury',filterLable:'DOI',width:'10rem'},
    {id: 'state', fid: 'state', numeric: false, disablePadding: true, label: 'State',filterLable:'State',width:'6rem'},
    {id: 'gender', fid: 'gender', numeric: false, disablePadding: true, label: 'Gender',filterLable:'Gender', width:'5rem'} 
];

function EnhancedTableHead(props) {
    const { classes,  order, orderBy,  onRequestSort, onRequestFilter } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };
    const onFilter = property => event => {
        onRequestFilter(event.target.value, property);

    };

    return (
        <TableHead>
            <TableRow>
                
                {headCells.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        style={{width:headCell.width}}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={order}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
          
            <TableRow className='filter-row'>
                        {headCells.map(headCell => (
                            <TableCell
                                key={headCell.id+1}
                                padding={headCell.disablePadding ? 'none' : 'normal'}
                                style={{ maxWidth: headCell.width, paddingBottom:0}}
                                autoFocus={headCell.id === 'claimNumber'}
                            >
                                <div  style={{paddingRight:'1rem',verticalAlign:'bottom'}}>
                                <TextField
                                    id="filterId"
                                    fullWidth
                                    autoFocus={headCell.id === 'claimNumber'}
                                    style={{height:'.7'}}
                                    placeholder={`Enter ${headCell.filterLable}`}
                                    margin="dense"
                                    variant="outlined"
                                    onChange={onFilter(headCell.id)}
                                />
                                </div>
                </TableCell>
                ))}

            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    onRequestFilter: PropTypes.func.isRequired,
};

const EnhancedTableToolbar = () => {

    return ({}
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number,
};

const useStyles1 = makeStyles(theme => ({
    root: {
      flexShrink: 0,
      marginLeft: theme.spacing(2.5),     
    },   
  }));

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();

    const { count, page, rowsPerPage, onPageChange, onChangePage } = props;
    const handlePageChange = onPageChange || onChangePage;

    const handleFirstPageButtonClick = event => {
        handlePageChange(event, 0);
    };

    const handleBackButtonClick = event => {
        handlePageChange(event, page - 1);
    };

    const handleNextButtonClick = event => {
        handlePageChange(event, page + 1);
    };

    const handleLastPageButtonClick = event => {
        handlePageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}               
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
      );
}


const useStyles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 450,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    visuallyHidden: {

        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
});

class claimSearchResultsTable extends Component{
    constructor(props) {
        super(props);
        this.state = {
            order: 'asc' ,orderBy:'claimNumber', page: 0, rowsPerPage: 10
          
        }

    }

    handleRequestSort = (event, property) => {
        const isDesc = this.state.orderBy === property && this.state.order === 'desc';
        this.setState({order: isDesc ? 'asc' : 'desc', orderBy: property});
    }

    handleRequestFilter = (value, property) => {
        console.log(`filter value->${value} and the property->${property}`)
        this.setState({ pageLastUsed: this.state.page });
       // let currentPage = this.state.page;
        if( value.length < 1){
            this.props.setFilter(this.props.claims);
            return true;
        }else{
            this.props.setFilter(this.props.claims.filter(claim => {
                let cValue = value.toUpperCase();
                let pValue = claim[property];
                if(("dob" === property) || ("doi" === property)){
                    pValue = formatDate(pValue);
                }
                if(pValue && pValue.toUpperCase().search(cValue) !== -1) {
                    this.setState({ page: 0 });
                    return claim[property];
                    
                }
                return false;
            }))
        }

    }

    

    handleChangePage = (event, newPage) => {
        this.setState({page: newPage})
    }

    handleChangeRowsPerPage = event => {
        this.setState({page: 0, rowsPerPage: event.target.value})
    }

    isSelected = name => this.props.selected.indexOf(name) !== -1;

    render() {
        const {classes} = this.props;

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                {/*  <EnhancedTableToolbar numSelected={selected.length} />*/}
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50, 100, 200]}
                    component="div"
                    count={this.props.claimsFiltered.length}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    ActionsComponent={TablePaginationActions}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                />
                <div className={classes.tableWrapper}>

                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size='small'
                        aria-label="Claim Results table"
                    >
                        <EnhancedTableHead
                            classes={classes}
                            order={this.state.order}
                            orderBy={this.state.orderBy}
                            onRequestSort={this.handleRequestSort}
                            rowCount={this.props.claimsFiltered.length}
                            onRequestFilter={this.handleRequestFilter}
                        />
                        <TableBody>
                            {stableSort(this.props.claimsFiltered, getSorting(this.state.order, this.state.orderBy))
                                .slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                                .map((row, index) => {
                                   
                                    const labelId = `enhanced-table-Select-${index}`;

                                    return (
                                        <TableRow
                                            hover
                                            tabIndex={-1}
                                            key={index}
                                          >

                                <TableCell component="th" id={labelId} scope="row" >
                                     {row.claimNumber}
                                 </TableCell>
                                 <TableCell component="th" id={labelId} scope="row" >
                                     {row.claimantName}
                                 </TableCell>   
                                 <TableCell component="th" id={labelId} scope="row" >
                                      {formatDate(row.dob)}
                                 </TableCell>
                                 <TableCell component="th" id={labelId} scope="row" >
                                    {formatDate(row.doi)}
                                 </TableCell>
                                 <TableCell component="th" id={labelId} scope="row" >
                                     {row.state}
                                 </TableCell>
                                 <TableCell component="th" id={labelId} scope="row" >
                                     {row.gender}
                                 </TableCell>
                                        </TableRow>
                                    );
                                })}

                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25, 50, 100, 200]}                                    
                                    count={this.props.claimsFiltered.length}
                                    rowsPerPage={this.state.rowsPerPage}
                                    page={this.state.page}
                                    ActionsComponent={TablePaginationActions}
                                    onPageChange={this.handleChangePage}
                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </div>               
            </Paper>

        </div>
    );
  }

}
export default withStyles(useStyles)(claimSearchResultsTable);
